// extracted by mini-css-extract-plugin
export default {"advanced-prompts":"AdvancedPrompts_advanced-prompts__rTcfw","advanced-prompts-list":"AdvancedPrompts_advanced-prompts-list__NJVpj"};